var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',{staticClass:"title"},[_c('img',{attrs:{"src":require("../assets/pokedex_logo.png"),"alt":"pokedex logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }